import {ReviewsData} from "./ReviewsData";
import islands50 from '../../assets/img/photo/review/islands-50.jpg';
import islands51 from '../../assets/img/photo/review/islands-51.jpg';
import islands52 from '../../assets/img/photo/review/islands-52.jpg';
import islands53 from '../../assets/img/photo/review/islands-53.webp';
import islands57 from '../../assets/img/photo/review/islands-57.webp';
import isalnds55 from '../../assets/img/photo/review/islands-55.webp';
import islands56 from '../../assets/img/photo/review/islands-56.webp';
import islands58 from '../../assets/img/photo/review/islands-58.jpg';
import noBgAvatar from '../../assets/img/photo/review/no-bg-preview .png';




export const ReviewsSlide = (): ReviewsData[] => [
    {
        name: 'Мария',
        review: 'Прекрасная идея, много интересных игр для детей. Классно, что мой ребёнок был полностью\n' +
            ' погружён в игру и с большим удовольствием провёл в "Вау.. Праздник!!!" 2 часа, а после спросил\n' +
            ' меня когда мы придём с ним сюда в следующий раз. В целом очень удачная планировка,\n' +
            ' всё продумано, удобно и комфортно! Очень чисто - что для меня играет большую роль!!!',
        avatar: islands50
    },
    {
        name: 'Антонина',
        review: 'Хочу выразить огромное спасибо игрушечной. Праздновали День Рождения дочери.\n' +
            'Все прошло просто замечательно. Дети довольные играли, родители отдыхали.\n' +
            'Девчонки заранее все подготовили, стол, оформление, даже взяли на себя доставку тортика,\n' +
            ' за что отдельное спасибо. В игрушечной все есть для праздника, посуда, чайник.\n' +
            ' Мы остались очень довольны. Желаю дальнейшего процветания и удачи! Молодцы! Так держать!!!',
        avatar: islands51
    },
    {
        name: 'Cветлана',
        review: 'Здравствуйте! Очень-очень понравилась в "Вау.. Праздник!!!", дочка отмечала день рожденье в стиле\n' +
            '«Пижамная вечеринка». Восторг, радость, красивая комната, очень вежливые и замечательные\n' +
            'ведущие, сам дизайн в современных спокойных тонах)))) и фотограф сделала красивейшие фотографии на\n' +
            'память! Всё, что осталось на столе, ведущие упаковали нам домой. Программа вечеринки очень интересная,\n' +
            'как раз для девочек 10-12 лет отлично подходит!!!\n' +
            'Благодарим Вас за такое прекрасное место и за великолепную организацию праздника.',
        avatar: islands53
    },
    {
        name: 'Олег',
        review: 'Продуманный дизайн, уютная атмосфера и разнообразие игр и развивающих занятий.\n' +
            'Здесь чисто, комфортно и безопасно для детей. Профессиональный персонал создает гостеприимную\n' +
            'обстановку.\n' +
            'Рекомендую это волшебное место всем, кто ценит радость и развитие детей.',
        avatar: islands57
    },
    {
        name: 'Сергей',
        review: 'Хочу сказать огромное спасибо команде "Вау.. Праздник!!!" за волшебный день для нашей дочки!\n' +
            'Честно, во-первых — думал ну, аниматоры как аниматоры, уже не раз были на праздниках.\n' +
            'Но тут… это был прям какой-то отдельный мир! Всё — от костюмов до сценария — продумано до\n' +
            'мелочей.\n' +
            'Даже взрослым было интересно и смешно, и трогательно, и снова смешно.',
        avatar: noBgAvatar
    },
    {
        name: 'Ольга',
        review: 'Моя дочка была на дне рождения у подружки в "Вау.. Праздник!!!". Атмосфера очень понравилась,\n' +
            'дети были заняты играми и веселились от души. Дочка вернулась домой с кучей впечатлений и\n' +
            'теперь просит отметить свой праздник тоже там!',
        avatar: isalnds55
    },
    {
        name: 'Илона',
        review: 'Любимое место время препровождения в городе! Всегда море впечатлений, океан позитива и масса\n' +
            'восторга.И нам-родителям ни менее интересно, чем детям!!! В ненастную\n' +
            'погоду просто палочка-выручалочка для каждой мамы. Развивающая позитивная среда для любимых\n' +
            'деток. Благодарим организаторов и желаем процветания, вдохновения и дальнейших успехов.',
        avatar: islands56
    },
    {
        name: 'Сергей',
        review: 'Очень круто повеселились в "Ваую... Праздник!!!".\n' +
            'Администрация отзывчивая, помогут устроить праздник любого формата.\n' +
            'Молодцы, ребята! Так держать!',
        avatar: islands52
    },
    {
        name: 'Анастасия',
        review: 'Спасибо большущее. Наш первый юбилей удался на все 100.\n' +
            'Все продумано до мелочей, каждый момент, все подскажут и\n' +
            'посоветуют. Дети и взрослые получили массу впечатлений. Спасибо)',
        avatar: islands58
    },
]